let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f8oA0")).then(() => parcelRequire('bsDwg'));